// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-contacts-indexstyleGrid-container-qqbwv{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-company-contacts-indexstyleGrid-grid-ltkbk{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-contacts-indexstyleGrid-col6-mzzwg{grid-column:span 6}.pages-company-contacts-indexstyleGrid-col3-bqvhc{grid-column:span 3}.pages-company-contacts-indexstyleGrid-col4-viqka{grid-column:span 4}.pages-company-contacts-indexstyleGrid-col9-cdgrh{grid-column:span 9}.pages-company-contacts-indexstyleGrid-col12-bzqwr{grid-column:span 12}.pages-company-contacts-indexstyleGrid-alignItemsStart-becoh{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-contacts-indexstyleGrid-container-qqbwv",
	"grid": "pages-company-contacts-indexstyleGrid-grid-ltkbk",
	"col6": "pages-company-contacts-indexstyleGrid-col6-mzzwg",
	"col3": "pages-company-contacts-indexstyleGrid-col3-bqvhc",
	"col4": "pages-company-contacts-indexstyleGrid-col4-viqka",
	"col9": "pages-company-contacts-indexstyleGrid-col9-cdgrh",
	"col12": "pages-company-contacts-indexstyleGrid-col12-bzqwr",
	"alignItemsStart": "pages-company-contacts-indexstyleGrid-alignItemsStart-becoh"
};
module.exports = ___CSS_LOADER_EXPORT___;
